<div class="row row-title">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12">
        <span class="title">{{title}}</span>
        <span class="view">{{subtitle}}</span>
    </div>
</div>
<ng-content></ng-content>